import React from 'react'
import s from './HeaderIndicator.module.scss'

export function HeaderIndicator(props) {
  return (
    <div className={s.hi} />
  )
}